import React from 'react';
import { AppService } from '@aperza/util';
import style from './UserProfileTile.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
export function UserProfileTile() {
    const { user, userPhotoUrl } = useAperzaUserContext();
    return (React.createElement("div", { className: style.userTile },
        React.createElement("div", { className: style.userAvatar },
            userPhotoUrl && React.createElement("img", { src: userPhotoUrl, alt: user.displayName, width: 50, height: 50 }),
            !userPhotoUrl && (React.createElement("img", { src: `${AppService.staticServerHost()}/common/images/header/user_white.svg`, alt: user.displayName, width: 30, height: 30 }))),
        React.createElement("div", { className: style.userInfo },
            React.createElement("div", { className: style.userFullName }, `${user.lastName ?? ''} ${user.firstName ?? ''} 様`),
            React.createElement("div", { className: style.userDisplayName },
                "\u8868\u793A\u540D: ",
                user.displayName),
            React.createElement("div", { className: style.userMailAddress },
                "\u30A2\u30DA\u30EB\u30B6ID: ",
                user.mailAddress))));
}
